<template>
  <z-input
    key="input"
    class="selected-values-input"
    style="width: 100%"
    hide-details
    small
    append-icon="$search"
    :placeholder="inputPlaceholder"
    :value="inputValue"
    v-on="$listeners"
  >
    <template #prepend-inner>
      <slot name="value" :value="value">
        <div
          class="d-flex flex-wrap"
          style="width: 100%; max-width: 100%; gap: 5px"
        >
          <transition-group
            tag="div"
            name="list"
            class="d-flex flex-wrap"
            style="gap: 5px; max-width: 100%"
          >
            <template v-for="(item, idx) in displayedValues">
              <z-chip
                :key="idx"
                x-small
                selected
                :title="getChipTitleText(item)"
                :close="!item.isAdditionalItems"
                :text="item.text"
                :color="item.color || 'var(--primary)'"
                @click="onChipClick(item)"
                @keyup.enter="onChipClick(item)"
                @click:close="$emit('click:remove', item)"
              ></z-chip>
            </template>
          </transition-group>

          <z-chip
            v-if="showAll || value.length > maxDisplayedValues"
            x-small
            color="var(--primary)"
            :text="showAll ? `- ${$t('show_less')}` : `+ ${$t('show_all')}`"
            @keyup.enter="$emit('update:show-all', !showAll)"
            @click="$emit('update:show-all', !showAll)"
          ></z-chip>
        </div>
      </slot>
    </template>
  </z-input>
</template>

<script>
export default {
  name: 'ZSelectedValuesInput',
  props: {
    inputValue: {
      type: String,
      default: '',
    },
    inputPlaceholder: {
      type: String,
      default: '',
    },

    value: {
      type: Array,
      default: () => [],
    },

    showAll: {
      type: Boolean,
      default: false,
    },

    maxDisplayedValues: {
      type: Number,
      default: 50,
    },
  },

  computed: {
    displayedValues() {
      if (this.showAll && this.value.length > this.maxDisplayedValues) {
        return this.value.slice(0, this.maxDisplayedValues).concat({
          isAdditionalItems: true,
          text: this.$t('more_n_itens', {
            n: this.value.length - this.maxDisplayedValues,
          }),
        })
      }

      if (this.showAll) return this.value

      return this.value.slice(0, this.maxDisplayedValues)
    },
  },

  methods: {
    onChipClick(item) {
      if (item.isAdditionalItems) {
        this.$emit('click:additional-items')
      }
    },

    getChipTitleText(item) {
      if (item.isAdditionalItems) {
        return this.value
          .slice(this.maxDisplayedValues)
          .map((v) => v.text)
          .join(', ')
      }

      return item.text
    },
  },

  i18n: {
    messages: {
      en: {
        show_all: 'Show all',
        show_less: 'Show less',
        more_n_itens: 'More {n} itens',
      },
      pt: {
        show_all: 'Ver todos',
        show_less: 'Ver menos',
        more_n_itens: 'Mais {n} itens',
      },

      es: {
        show_all: 'Ver más',
        show_less: 'Ver menos',
        more_n_itens: 'Más {n} itens',
      },
      fr: {
        show_all: 'Afficher tout',
        show_less: 'Afficher moins',
        more_n_itens: 'Plus de {n} éléments',
      },
      tr: {
        show_all: 'Hepsini göster',
        show_less: 'Daha az göster',
        more_n_itens: '{n} öğeden fazlası',
      },
    },
  },
}
</script>

<style scoped lang="scss">
.selected-values-input {
  :deep(.v-input__slot) {
    padding: 5px 12px !important;
    height: auto !important;
    flex-direction: column !important;
  }

  :deep(.v-input__prepend-inner) {
    max-width: 100%;
    margin-top: 0px !important;
    align-self: center !important;
  }

  :deep(.v-input__append-inner) {
    margin: 0px !important;
    position: absolute;
    bottom: 4px;
    right: 5%;
  }

  :deep(input) {
    max-width: calc(100% - 30px);
  }

  :deep(.v-chip .v-chip__close.v-icon) {
    font-size: 15px !important;
  }
}

.list-move,
.list-enter-active,
.list-leave-active {
  transition: all 0.3s;
}

.list-enter,
.list-leave-to {
  opacity: 0;
}

.list-leave-active {
  position: absolute;
}
</style>
